import { useRouter } from 'next/router'
import Head from 'next/head'

import { historyUtils } from '@wartek-id/toolbox-helper'
import { Icon } from '@wartek-id/icon-v2'

import type { FC } from 'react'

interface ProfileHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  classNameSubContainer?: string
  onClickBack?: Function
  title?: string
}

const ProfileHeader: FC<ProfileHeaderProps> = ({
  className = '',
  classNameSubContainer = '',
  children = '',
  onClickBack,
  title = 'Ruang GTK',
}) => {
  const router = useRouter()

  return (
    <div className={className}>
      <Head>
        <title>{title}</title>
      </Head>
      <div className={classNameSubContainer}>
        <button
          className="m-4 leading-none"
          onClick={
            onClickBack
              ? () => onClickBack()
              : () => {
                  historyUtils.backToApp(router.back)
                }
          }
        >
          <Icon>arrow_back</Icon>
        </button>
        {children}
      </div>
    </div>
  )
}
export default ProfileHeader
